import React, { useState, useRef, useImperativeHandle } from 'react';
import { message, Spin } from 'antd';
import FormPoints from '../FormPoints/FormPoints'; 
import FormSaveCancelToolbar from '../FormSaveCancelToolbar/FormSaveCancelToolbar'; 
import usePatchCourseMutation from '../../gql/hooks/usePatchCourse';
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';

const TabPoints = ( { form, isSavingCallback, ref } ) => {
    const formPointsRef = useRef( useRef );
    const [ isSaving, setIsSaving ] = useState( false );
    const [ isModified, setIsModified ] = useState( false );
    const { saveCourse } = usePatchCourseMutation();
    const [ openConfirm, setOpenConfirm ] = useState( false );

    useImperativeHandle( ref, () => ( {
        isModified() {
            return isModified;
        },
        showSaveConfirm() {
            setOpenConfirm( true );
        }
    } ) );
  
    const handleSave = async () => {
        setIsSaving( true );
        setOpenConfirm( false ); 
        isSavingCallback( true ); 

        const response = await saveCourse( courseFormUtils.getCourseSaveData( form ) );
        
        if ( response.success ) { 
            // Update form data to match what we just saved
            form.setFieldsValue( { points: form.getFieldValue( 'pointsModified' ) } ); 
            formPointsRef.current.reset(); 
            message.success( 'Course saved.' );
        } else {
            message.error( 'Error saving course!' ); 
        }

        setIsSaving( false );
        isSavingCallback( false );
    };

    const handleReset = () => {
        formPointsRef.current.reset();
        setOpenConfirm( false );
        isSavingCallback( false );
    };

    const handleModifiedChange = ( value ) => {
        setIsModified( value );
    };

    return (
        <div className="resources-tab tab-main-columns">
            <div className="left">
                <Spin spinning={ isSaving }>
                    <FormPoints 
                        form={ form }
                        ref={ formPointsRef }
                        modifiedCallback={ handleModifiedChange } 
                    />
                </Spin>
            </div>

            <div className="right">
                <FormSaveCancelToolbar
                    form={ form } 
                    open={ openConfirm }
                    saving={ isSaving }
                    modified={ isModified }
                    saveCallback={ handleSave }
                    cancelCallback={ handleReset }
                />
            </div>
        </div>
    );
};

export default TabPoints;
